import { genericToolTip } from '@y42/gojs';
import { JobStatusToIcon, StatusName } from '@y42/job';
import { JobStatus } from '@y42/json-schema';
import { Binding } from 'gojs';
import {
  dataLineageDiagramConfig,
  DataLineageNodeBinding,
  DataLineageUINode,
} from '../../../../../../state/data-lineage-diagram';
import { nameBinding } from '../utils/shared-bindings';

const defaultTooltipColors = {
  colors: { fill: dataLineageDiagramConfig.tooltip.background, stroke: dataLineageDiagramConfig.tooltip.fontColor },
};

export const groupHeaderTextToolTip = () =>
  genericToolTip(defaultTooltipColors, [nameBinding()], [nameTooltipVisibilityBinding()]);

export const entityTypeLogoTooltip = () => genericToolTip(defaultTooltipColors, [entityLogoTooltipBinding()]);
const entityLogoTooltipBinding = () =>
  new Binding('text', '', (node: DataLineageUINode) => {
    return node[DataLineageNodeBinding.DeletedEntity]
      ? `"${node.key}" is deleted`
      : !node[DataLineageNodeBinding.HasReadPermission]
      ? 'You do not have read access to this asset'
      : node[DataLineageNodeBinding.ItemType];
  });

export const readPermissionTooltipBinding = (text: string, textPermissionNotAllowed: string) =>
  new Binding('text', '', (node: DataLineageUINode) => {
    return !node[DataLineageNodeBinding.HasReadPermission] ? textPermissionNotAllowed : text;
  });

export const subEntityTypeLogoTooltip = () =>
  genericToolTip(
    defaultTooltipColors,
    [subEntityLogoTooltipBinding()],
    [new Binding('visible', DataLineageNodeBinding.DeletedEntity)],
  );
const subEntityLogoTooltipBinding = () =>
  new Binding('text', '', (node: DataLineageUINode) => {
    return `"${node.key}" is deleted`;
  });

const nameTooltipVisibilityBinding = () =>
  new Binding('visible', DataLineageNodeBinding.Name, (name: string) => {
    return name?.length > dataLineageDiagramConfig.group.textLength;
  });

// Node Status Tooltip
export const nodeStatusTooltip = () => genericToolTip(defaultTooltipColors, [nodeStatusTooltipTextBinding()]);

const nodeStatusTooltipTextBinding = () =>
  new Binding('text', DataLineageNodeBinding.Status, (status: JobStatus | null) =>
    status ? `Last Job: ${JobStatusToIcon[status].label}` : StatusName.NoJob,
  );
